export default class AutoCompleteToggle
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...AutoCompleteToggle.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$autoComplete = this.DOM.$el.querySelector(this.options.selectorAutoComplete)
        this.DOM.$container = this.DOM.$el.querySelector(this.options.selectorContainer)
        this.DOM.$template = this.DOM.$el.querySelector(this.options.selectorTemplate)

        if (this.DOM.$autoComplete) {
            this.DOM.$autoCompleteInput = this.DOM.$autoComplete.querySelector('input')
        }

        if (this.DOM.$template) {
            this.template = _.template(this.DOM.$template.innerHTML)
            this.DOM.$autoComplete.addEventListener('autocomplete:select', this.onAutoCompleteSelect.bind(this))
        }
    }

    onAutoCompleteSelect(e) {
        if (this.DOM.$autoCompleteInput) {
            if (this.DOM.$autoCompleteInput.hasOwnProperty('autoComplete')) {
                this.DOM.$autoCompleteInput.autoComplete.clear()
            }
        }

        this.DOM.$el.classList.add(this.options.classNameIsSelected)

        const $result = document.createElement('div')
        $result.innerHTML = this.template(e.detail)

        const $reset = $result.querySelector(this.options.selectorReset)
        $reset.addEventListener('click', this.onReset.bind(this), { once: true })

        this.DOM.$container.appendChild($result)
    }

    onReset() {
        this.DOM.$el.classList.remove(this.options.classNameIsSelected)
        this.DOM.$container.innerHTML = ''

        const $input = this.DOM.$autoComplete.querySelector('input')
        $input.value = ''
        const $selected = document.getElementById(`${$input.id}-selected`);
        $selected.value = ''

        setTimeout(() => {
            $input.focus()
        }, 25)
    }
}

AutoCompleteToggle.prototype.defaults = {
    classNameIsSelected: 'is-selected',
    selectorAutoComplete: '.js-autoCompleteToggleAutoComplete',
    selectorContainer: '.js-autoCompleteToggleContainer',
    selectorReset: '.js-autoCompleteToggleReset',
    selectorTemplate: '.js-autoCompleteToggleTemplate',
}